<div class="page-padding">
  <header-top *ngIf="!_print_version"></header-top>
  <div *ngIf="!_print_version" class="widget-container">
    <fleet-condition-widget *ngIf="!hideStatus('fleet-condition-widget')" [chartid]="1"></fleet-condition-widget>
    <inspections-performed-widget *ngIf="!hideStatus('inspections-performed-widget')" [chartid]="2"></inspections-performed-widget>
    <cost-of-repairs-monthly-widget *ngIf="!hideStatus('cost-of-repairs-monthly-widget')" [chartid]="3"></cost-of-repairs-monthly-widget>
    <components-on-eval-widget *ngIf="!hideStatus('components-on-eval-widget')" [chartid]= "5" ></components-on-eval-widget>
    <app-inspections-due-widget *ngIf="!hideStatus('app-inspections-due-widget')" [chartid]="4"></app-inspections-due-widget>
  </div>
  <div class="panel">
    <nav mat-tab-nav-bar>
        <!-- <button *ngIf="_exportStatus > 0" mat-icon-button [matMenuTriggerFor]="Tablemenu" style="position:absolute;right:0;"> -->
        <button *ngIf="_exportStatus > 0" mat-icon-button (click)="exportClicked(2)" style="position:absolute;right:0;" title="Export CSV">
          <mat-icon>save_alt</mat-icon>

        </button>
        <!-- <button *ngIf="_exportStatus > 0"  mat-raised-button  color="warn"  (click)="openFleetReport()"  class="buttonOpem">{{'Fleet Reporting' | translate | async}}</button> -->
        <button  *ngIf="_exportStatus > 0" mat-raised-button  color="warn"  (click)="navigateToSetupEquipment()" style="position: absolute; right: 0;margin-right: 60px;margin-top: 4px;">{{'Setup New Equipment' | translate | async}}</button>

        <!-- <mat-paginator *ngIf="activeLinkIndex == 1" #componentPaginatorTopLevel [pageSize]="loadSize" [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="componentPageChanged($event)">
        </mat-paginator>
        <mat-paginator *ngIf="activeLinkIndex == 0" #fleetPaginatorTopLevel [pageSize]="loadSize" [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="fleetConditionChanged($event)">
        </mat-paginator>  -->
        <!-- <mat-menu #Tablemenu="matMenu">
            <button mat-menu-item (click)="exportClicked(1)">
                <mat-icon>insert_drive_file</mat-icon>
                <span>PDF</span>
            </button>
            <button mat-menu-item (click)="exportClicked(2)">
              <mat-icon>insert_drive_file</mat-icon>
              <span>CSV</span>
          </button>

        </mat-menu> -->


      <a mat-tab-link *ngFor="let routeLink of routeLinks; let i = index;"
         [routerLink]="routeLink.link"
         [active]="_router.url.includes(routeLink.link) ||(routeLink.link.includes('/components') && !_router.url.includes('/fleet') && !_router.url.includes('/wears'))"
         routerLinkActive #rla="routerLinkActive"
         (click)="activeLinkIndex = i">
        {{ routeLink.label | translate | async}}
      </a>
    </nav>
    <router-outlet></router-outlet>
  </div>
</div>
<!--tt843 [active]="_router.url.includes(routeLink.link) || (routeLink.link.includes('/fleet') && !_router.url.includes('/components'))" -->
